import React, { useEffect, useState } from "react";
import apiClient from "../api.js";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FaCarRear } from "react-icons/fa6";
import { LuPhoneCall, LuIndianRupee } from "react-icons/lu";

const Popup = ({ data }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [subject, setSubject] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    if (data) {
      setSubject(data);
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      const res = await apiClient.post("emailsend/send-email", {
        email,
        subject,
        mobile,
        name,
      });

      if (res) {
        // Hide the main form popup
        const mainPopup = document.getElementById("staticBackdrop");
        if (mainPopup) {
          const bootstrapModal = window.bootstrap.Modal.getInstance(mainPopup);
          if (bootstrapModal) bootstrapModal.hide();
        }
        navigate("/thank-you"); // Redirect after successful response
        // window.location.reload(); // Forces a full page reload
        setShowSuccessPopup(true); // Show success popup
        setEmail("");
        setName("");
        setMobile("");
        setSubject("");
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate("/thankyou"); // Redirect or perform other actions if necessary
    window.location.reload(); // Forces a full page reload
  };

  return (
    <>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog enq-modal modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 class="modal-title text-center">Enquire Now</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="d-flex">
                <div className="flex-fill align-self-center flex-shrink-0 modal-highlight-bg d-none d-lg-block">
                  <span className="modal-highlight-title">We Promise</span>
                  <ul className="modal-highlight">
                    <li>
                      <LuPhoneCall className="popup-icon" />
                      <span>Instant Call Back</span>
                    </li>
                    <li>
                      <FaCarRear className="popup-icon" />
                      <span>Free Site Visit</span>
                    </li>
                    <li>
                      <LuIndianRupee className="popup-icon" />
                      <span>Unmatched Price</span>
                    </li>
                  </ul>
                </div>
                <div className="lead-form-div">
                  <form onSubmit={handleSubmit} className="lead-form">
                    <input
                      placeholder="Name*"
                      className="lead-form-input"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />

                    <input
                      placeholder="Mobile*"
                      className="lead-form-input"
                      type="tel"
                      pattern="[789][0-9]{9}"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      required
                    />
                    <input
                      placeholder="Email*"
                      className="lead-form-input"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <input
                      className="lead-form-input"
                      type="hidden"
                      id="subjectName"
                      value={data}
                      required
                    />
                    <div className="download-brochure-btn-div">
                      <button
                        className={`form-enquire-btn ${
                          isSubmitting ? "disabled" : ""
                        }`}
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Enquire Now"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div
          className="modal-overlay"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-content success-popup">
            <button
              className="close-btn"
              onClick={handleSuccessPopupClose}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="w-100">
              <FaCheckCircle className="success-icon text-center" />
            </div>
            <h2>Thank you!</h2>
            <p>We've received your submission, and we'll be in touch soon!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
